export default __webpack_public_path__ + "static/Galileo-7cd119ebde6e4057b9c78da9eddf5941.mp4";